import { callApiToServer } from "../callApi";

export async function deleteInventory(authtoken, card_id, count, city) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Bearer " + authtoken,
    };
    let endUrl = `v1/auth/delete-inventory-by-card`;
    let body = {
      card_id,
      count,
      city,
    };

    let responseData = await callApiToServer(
      JSON.stringify(body),
      header,
      "POST",
      endUrl
    );

    return responseData;
  } catch (err) {
    throw err;
  }
}
